/**
 * EASE Salespage: ein offenes Accordion pro Gruppe (.ease-sp-details--single),
 * analog Radix type="single" collapsible.
 */
(function () {
  function initWaveBackgroundCanvas() {
    var canvas = document.getElementById('ease-wave-bg-canvas');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var rafId = null;
    var width = 0;
    var height = 0;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);

    function resize() {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function drawLine(time, index, count, color, alphaScale) {
      var progress = index / Math.max(1, count - 1);
      // Keep the wave field centered on screen (not bottom-heavy).
      var centerY = height * 0.5;
      var amplitude = 16 + progress * 36;
      var waveLength = 240 + progress * 180;
      var speed = 0.16 + progress * 0.22;
      var phase = time * speed * 0.001 + index * 0.47;

      // Subtle per-line drift so lines organically move up/down over time.
      var drift =
        Math.sin(time * 0.00015 + index * 1.91) * (8 + progress * 14) +
        Math.sin(time * 0.00009 + index * 0.77) * (5 + progress * 10);

      ctx.beginPath();
      for (var x = -80; x <= width + 80; x += 6) {
        var xNorm = Math.max(0, Math.min(1, (x + 80) / (width + 160)));
        // Hourglass profile: tight on edges, open in the center.
        var centerEnvelope = Math.pow(Math.sin(Math.PI * xNorm), 1.25);
        var spreadAtX = 16 + centerEnvelope * 250;
        var lineBase = centerY + (progress - 0.5) * spreadAtX + drift;
        var waveAmp = amplitude * (0.28 + centerEnvelope * 1.05);

        var y = lineBase;
        y += Math.sin((x / waveLength) + phase) * waveAmp;
        y += Math.sin((x / (waveLength * 0.48)) + phase * 1.16) * (waveAmp * 0.2);
        y += Math.sin((x / (waveLength * 1.7)) + phase * 0.72) * (waveAmp * 0.1);

        if (x <= -80) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }

      var alpha = (0.18 + progress * 0.22) * alphaScale;
      ctx.strokeStyle = 'rgba(' + color + ',' + alpha + ')';
      ctx.lineWidth = 1.1 + progress * 1.2;
      ctx.stroke();
    }

    function render(time) {
      ctx.clearRect(0, 0, width, height);

      // Keep strongest visibility around the center area.
      var fade = ctx.createLinearGradient(0, height * 0.12, 0, height * 0.9);
      fade.addColorStop(0, 'rgba(0,0,0,0)');
      fade.addColorStop(0.24, 'rgba(0,0,0,0.75)');
      fade.addColorStop(0.55, 'rgba(0,0,0,1)');
      fade.addColorStop(0.78, 'rgba(0,0,0,0.76)');
      fade.addColorStop(1, 'rgba(0,0,0,1)');

      ctx.save();
      ctx.globalCompositeOperation = 'source-over';

      var count = 14;
      for (var i = 0; i < count; i += 1) {
        drawLine(time, i, count, '184,150,12', 1);
      }
      for (var j = 0; j < 8; j += 1) {
        drawLine(time * 0.84, j, 8, '255,255,255', 0.52);
      }

      ctx.globalCompositeOperation = 'destination-in';
      ctx.fillStyle = fade;
      ctx.fillRect(0, 0, width, height);
      ctx.restore();

      rafId = window.requestAnimationFrame(render);
    }

    resize();
    window.addEventListener('resize', resize);
    rafId = window.requestAnimationFrame(render);

    window.addEventListener('pagehide', function () {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
      }
      window.removeEventListener('resize', resize);
    });
  }

  function initSingleAccordions(root) {
    root.querySelectorAll('.ease-sp-details--single').forEach(function (group) {
      group.querySelectorAll('details.ease-sp-accordion').forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          group.querySelectorAll('details.ease-sp-accordion').forEach(function (other) {
            if (other !== details) {
              other.removeAttribute('open');
            }
          });
        });
      });
    });
  }

  /**
   * Audience-Marquee mit Interaktion:
   * - Auto-Run
   * - Pause bei Hover (Desktop)
   * - Manuelles Schieben per Maus/Daumen
   * - Nach Loslassen läuft es normal weiter
   */
  function initAudienceMarquee(root) {
    if (prefersReducedMotion()) return;

    root = root || document;
    var sections = [];

    if (root.nodeType === 1 && root.matches && root.matches('.ease-salespage-audience-section')) {
      sections.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.ease-salespage-audience-section').forEach(function (el) {
        if (sections.indexOf(el) === -1) sections.push(el);
      });
    }

    sections.forEach(function (sec) {
      var strip = sec.querySelector('[data-ease-audience-marquee-strip]');
      var track = sec.querySelector('[data-ease-slider-track]');
      var viewport = sec.querySelector('[data-ease-audience-viewport]');
      if (!strip || !track || !viewport) return;

      if (strip._easeAudienceMarqueeCancel) {
        strip._easeAudienceMarqueeCancel();
        strip._easeAudienceMarqueeCancel = null;
      }

      strip.classList.add('ease-sp-audience__marquee-strip--js-marquee');

      var rafId = null;
      var cancelled = false;
      var paused = false;
      var dragging = false;
      var dragPointerId = null;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragStartOffset = 0;
      var dragIntentLocked = false;
      var dragIsHorizontal = false;
      var lastNow = performance.now();

      var loopMsDesktop = 70000;
      var loopMsMobile = 108000;
      var loopMs = loopMsDesktop;
      function syncAudienceMarqueeLoopMs() {
        try {
          loopMs = window.matchMedia('(max-width: 749px)').matches ? loopMsMobile : loopMsDesktop;
        } catch (_) {
          loopMs = loopMsDesktop;
        }
      }
      syncAudienceMarqueeLoopMs();
      var mqAudience749 = window.matchMedia && window.matchMedia('(max-width: 749px)');
      if (mqAudience749) {
        if (mqAudience749.addEventListener) mqAudience749.addEventListener('change', syncAudienceMarqueeLoopMs);
        else if (mqAudience749.addListener) mqAudience749.addListener(syncAudienceMarqueeLoopMs);
      }
      var offsetX = 0;

      function getHalf() {
        return Math.max(0, track.scrollWidth / 2);
      }

      function normalize(x, half) {
        if (half < 1) return 0;
        while (x <= -half) x += half;
        while (x > 0) x -= half;
        return x;
      }

      function applyTransform() {
        strip.style.transform = 'translate3d(' + offsetX + 'px,0,0)';
        strip.style.webkitTransform = 'translate3d(' + offsetX + 'px,0,0)';
      }

      function frame(now) {
        if (cancelled) return;
        if (!strip.isConnected) {
          if (rafId != null) window.cancelAnimationFrame(rafId);
          return;
        }

        var half = getHalf();
        if (half < 8) {
          lastNow = now;
          rafId = window.requestAnimationFrame(frame);
          return;
        }

        var dt = Math.min(80, Math.max(0, now - lastNow));
        lastNow = now;

        if (!paused && !dragging) {
          var speed = half / loopMs; // px per ms
          offsetX = normalize(offsetX - speed * dt, half);
          applyTransform();
        }

        rafId = window.requestAnimationFrame(frame);
      }

      function onMouseEnter() {
        paused = true;
      }

      function onMouseLeave() {
        if (!dragging) paused = false;
      }

      function onPointerDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        paused = true;
        dragPointerId = e.pointerId;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        dragStartOffset = offsetX;
        dragIntentLocked = false;
        dragIsHorizontal = false;
        viewport.classList.add('is-dragging');
        if (viewport.setPointerCapture) viewport.setPointerCapture(e.pointerId);
      }

      function onPointerMove(e) {
        if (!dragging || e.pointerId !== dragPointerId) return;
        var dx = e.clientX - dragStartX;
        var dy = e.clientY - dragStartY;

        if (!dragIntentLocked) {
          if (Math.abs(dx) + Math.abs(dy) < 8) return;
          dragIntentLocked = true;
          dragIsHorizontal = Math.abs(dx) >= Math.abs(dy);
        }

        if (!dragIsHorizontal) return;

        var half = getHalf();
        if (half < 8) return;
        e.preventDefault();
        offsetX = normalize(dragStartOffset + dx, half);
        applyTransform();
      }

      function endDrag(e) {
        if (!dragging) return;
        if (e && dragPointerId != null && e.pointerId !== dragPointerId) return;
        dragging = false;
        dragPointerId = null;
        dragIntentLocked = false;
        dragIsHorizontal = false;
        viewport.classList.remove('is-dragging');
        if (e && viewport.releasePointerCapture) {
          try {
            viewport.releasePointerCapture(e.pointerId);
          } catch (_) {}
        }
        if (!viewport.matches(':hover')) paused = false;
      }

      sec.addEventListener('mouseenter', onMouseEnter);
      sec.addEventListener('mouseleave', onMouseLeave);
      viewport.addEventListener('pointerdown', onPointerDown, { passive: true });
      viewport.addEventListener('pointermove', onPointerMove, { passive: false });
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('lostpointercapture', endDrag);

      rafId = window.requestAnimationFrame(frame);

      strip._easeAudienceMarqueeCancel = function () {
        cancelled = true;
        if (rafId != null) window.cancelAnimationFrame(rafId);
        sec.removeEventListener('mouseenter', onMouseEnter);
        sec.removeEventListener('mouseleave', onMouseLeave);
        viewport.removeEventListener('pointerdown', onPointerDown);
        viewport.removeEventListener('pointermove', onPointerMove);
        viewport.removeEventListener('pointerup', endDrag);
        viewport.removeEventListener('pointercancel', endDrag);
        viewport.removeEventListener('lostpointercapture', endDrag);
        viewport.classList.remove('is-dragging');
        strip.style.transform = '';
        strip.style.webkitTransform = '';
        strip.classList.remove('ease-sp-audience__marquee-strip--js-marquee');
      };
    });
  }

  function initEaseHorizontalSliders(root) {
    root.querySelectorAll('[data-ease-slider]').forEach(function (slider) {
      if (slider.getAttribute('data-ease-slider-bound') === '1') return;
      var track = slider.querySelector('[data-ease-slider-track]');
      if (!track) return;
      slider.setAttribute('data-ease-slider-bound', '1');

      var viewport = slider.querySelector('[data-ease-slider-viewport]');
      var scroller = viewport || track;

      function scrollByStep(dir) {
        var slide =
          track.querySelector('[data-ease-slider-slide]') ||
          track.querySelector('.ease-sp-audience__card:not(.ease-sp-audience__card--marquee-clone)') ||
          track.querySelector('.ease-sp-audience__card') ||
          track.children[0];
        if (!slide) return;
        var step = slide.getBoundingClientRect().width;
        var gapRaw = window.getComputedStyle(track).gap;
        var gap = parseFloat(gapRaw) || 16;
        scroller.scrollBy({ left: dir * (step + gap), behavior: 'smooth' });
      }

      slider.querySelectorAll('[data-ease-slider-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-ease-slider-dir') === 'next' ? 1 : -1;
          scrollByStep(dir);
        });
      });
    });
  }

  function initEaseApplicationsCarousel(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-ease-apps-carousel]').forEach(function (carousel) {
      if (carousel.getAttribute('data-ease-apps-carousel-bound') === '1') return;

      var viewport = carousel.querySelector('[data-ease-apps-carousel-viewport]');
      var track = carousel.querySelector('[data-ease-apps-carousel-track]');
      if (!viewport || !track) return;

      carousel.setAttribute('data-ease-apps-carousel-bound', '1');

      var loopFixing = false;
      var smooth = !prefersReducedMotion();

      function getLoopWidth() {
        var firstClone = track.querySelector('[data-slider-clone]');
        return firstClone ? firstClone.offsetLeft : 0;
      }

      function getRealSlides() {
        return Array.prototype.slice.call(
          track.querySelectorAll('[data-ease-slider-slide]:not([data-slider-clone])')
        );
      }

      function getScrollTargetForSlide(slide) {
        if (!slide) return 0;
        var slideW = slide.getBoundingClientRect().width;
        return slide.offsetLeft - (viewport.clientWidth - slideW) / 2;
      }

      function getActiveIndex() {
        var slides = getRealSlides();
        if (!slides.length) return 0;

        var sl = viewport.scrollLeft;
        var loopW = getLoopWidth();
        if (loopW > 0 && sl >= loopW - 2) sl -= loopW;

        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(getScrollTargetForSlide(slide) - sl);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function scrollToIndex(index, behavior) {
        var slides = getRealSlides();
        if (!slides.length) return;
        var n = slides.length;
        var i = ((index % n) + n) % n;
        viewport.scrollTo({
          left: Math.max(0, getScrollTargetForSlide(slides[i])),
          behavior: behavior || 'auto',
        });
      }

      function normalizeLoop() {
        if (loopFixing) return;
        var loopW = getLoopWidth();
        if (loopW < 1) return;

        var sl = viewport.scrollLeft;
        if (sl >= loopW - 2) {
          loopFixing = true;
          viewport.scrollLeft = sl - loopW;
          loopFixing = false;
        }
      }

      function scrollByStep(dir) {
        var slides = getRealSlides();
        var n = slides.length;
        if (!n) return;

        var behavior = smooth ? 'smooth' : 'auto';
        var i = getActiveIndex();
        var next = i + dir;
        var loopW = getLoopWidth();

        if (next < 0) {
          scrollToIndex(n - 1, behavior);
          return;
        }

        if (next >= n) {
          var firstClone = track.querySelector('[data-slider-clone]');
          var cloneTarget = firstClone
            ? getScrollTargetForSlide(firstClone)
            : loopW + getScrollTargetForSlide(slides[0]);
          viewport.scrollTo({ left: Math.max(0, cloneTarget), behavior: behavior });
          return;
        }

        scrollToIndex(next, behavior);
      }

      function jumpToStart() {
        var slides = getRealSlides();
        if (!slides.length) {
          viewport.scrollLeft = 0;
          return;
        }
        viewport.scrollLeft = Math.max(0, getScrollTargetForSlide(slides[0]));
      }

      viewport.addEventListener('scroll', normalizeLoop, { passive: true });

      carousel.querySelectorAll('[data-ease-apps-carousel-dir]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var dir = btn.getAttribute('data-ease-apps-carousel-dir') === 'next' ? 1 : -1;
          scrollByStep(dir);
        });
      });

      jumpToStart();
      window.requestAnimationFrame(jumpToStart);
      window.addEventListener(
        'resize',
        function () {
          jumpToStart();
        },
        { passive: true }
      );
    });
  }

  function initAudienceSliders(root) {
    initEaseHorizontalSliders(root);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateEaseJourneyTimelines() {
    if (prefersReducedMotion()) return;

    document.querySelectorAll('[data-ease-timeline-root]').forEach(function (root) {
      var container = root.querySelector('[data-ease-tl-container]');
      var entries = root.querySelectorAll('[data-ease-tl-entry]');
      if (!container || !entries.length) return;

      var containerRect = container.getBoundingClientRect();
      var containerTop = containerRect.top;
      var containerHeight = containerRect.height;
      var windowH = window.innerHeight;
      var triggerPoint = windowH * 0.75;

      var scrolled = triggerPoint - containerTop;
      var progress = Math.max(0, Math.min(1, scrolled / containerHeight));
      container.style.setProperty('--ease-tl-fill-px', progress * containerHeight + 'px');

      entries.forEach(function (entry) {
        var rect = entry.getBoundingClientRect();
        if (rect.top < triggerPoint) {
          entry.classList.add('is-visible');
        }
      });
    });
  }

  function initEaseJourneyTimelines() {
    if (window.__easeJourneyScrollBound) {
      updateEaseJourneyTimelines();
      return;
    }
    window.__easeJourneyScrollBound = true;

    function tick() {
      updateEaseJourneyTimelines();
    }

    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    document.addEventListener('shopify:section:load', tick);

    tick();
    setTimeout(tick, 100);
  }

  function initEaseScrollTargets(root) {
    root = root || document;
    if (!root.querySelectorAll) return;

    function smoothScrollToId(targetId) {
      if (!targetId) return;
      var anchorEl =
        document.getElementById(targetId) ||
        document.querySelector('[id^="' + targetId + '"]') ||
        document.querySelector('#ease-product-info-target') ||
        document.querySelector('product-info[data-section="main"]') ||
        document.querySelector('product-info[id^="MainProduct-"]');
      if (!anchorEl) return;

      var productInfo = anchorEl.closest && anchorEl.closest('product-info') ? anchorEl.closest('product-info') : anchorEl;
      var mediaTopEl =
        (productInfo && productInfo.querySelector && productInfo.querySelector('media-gallery')) ||
        (productInfo && productInfo.querySelector && productInfo.querySelector('.product__media-wrapper')) ||
        anchorEl;

      if (prefersReducedMotion()) {
        mediaTopEl.scrollIntoView({ block: 'start' });
        return;
      }

      var start = window.pageYOffset || document.documentElement.scrollTop || 0;
      var rect = mediaTopEl.getBoundingClientRect();
      var target = Math.max(0, start + rect.top - 100);
      var distance = target - start;
      if (Math.abs(distance) < 2) return;
      var duration = Math.min(1200, Math.max(700, Math.abs(distance) * 0.6));

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      var t0 = performance.now();
      function step(now) {
        var p = Math.min(1, (now - t0) / duration);
        var y = start + distance * easeInOutCubic(p);
        window.scrollTo(0, y);
        if (p < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }

    root.querySelectorAll('[data-ease-scroll-target]').forEach(function (el) {
      if (el.getAttribute('data-ease-scroll-bound') === '1') return;
      el.setAttribute('data-ease-scroll-bound', '1');
      el.addEventListener('click', function (e) {
        var targetId = el.getAttribute('data-ease-scroll-target');
        if (!targetId) return;
        e.preventDefault();
        smoothScrollToId(targetId);
      });
    });
  }

  /** Community: Instagram-ähnliche Highlights + 9:16-Lightbox (ein State für alle Sections). */
  var easeCommunityHlState = {
    lb: null,
    urls: [],
    idx: 0
  };

  function easeCommunityHlGetEls(lb) {
    return {
      img: lb.querySelector('.ease-sp-community-lightbox__img'),
      idxEl: lb.querySelector('[data-ease-hl-idx]'),
      totalEl: lb.querySelector('[data-ease-hl-total]')
    };
  }

  function easeCommunityHlShow() {
    var st = easeCommunityHlState;
    if (!st.lb || !st.urls.length) return;
    var els = easeCommunityHlGetEls(st.lb);
    if (els.img) {
      els.img.src = st.urls[st.idx];
      els.img.alt = 'Bild ' + (st.idx + 1) + ' von ' + st.urls.length;
    }
    if (els.idxEl) els.idxEl.textContent = String(st.idx + 1);
    if (els.totalEl) els.totalEl.textContent = String(st.urls.length);
  }

  function easeCommunityHlClose() {
    var st = easeCommunityHlState;
    if (!st.lb) return;
    st.lb.setAttribute('hidden', '');
    var els = easeCommunityHlGetEls(st.lb);
    if (els.img) {
      els.img.removeAttribute('src');
      els.img.alt = '';
    }
    st.lb = null;
    st.urls = [];
    st.idx = 0;
    document.body.style.overflow = '';
  }

  function easeCommunityHlStep(delta) {
    var st = easeCommunityHlState;
    if (!st.lb || !st.urls.length) return;
    st.idx = (st.idx + delta + st.urls.length) % st.urls.length;
    easeCommunityHlShow();
  }

  function easeCommunityHlOpen(lb, urls) {
    var st = easeCommunityHlState;
    st.lb = lb;
    st.urls = urls;
    st.idx = 0;
    lb.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    easeCommunityHlShow();
    var closeBtn = lb.querySelector('.ease-sp-community-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function easeCommunityHlOnKeydown(e) {
    if (!easeCommunityHlState.lb) return;
    if (e.key === 'Escape') {
      easeCommunityHlClose();
      e.preventDefault();
    } else if (e.key === 'ArrowLeft') {
      easeCommunityHlStep(-1);
      e.preventDefault();
    } else if (e.key === 'ArrowRight') {
      easeCommunityHlStep(1);
      e.preventDefault();
    }
  }

  function bindCommunityLightbox(lb) {
    if (lb.__easeHlLbBound) return;
    lb.__easeHlLbBound = true;

    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-ease-hl-close]')) {
        easeCommunityHlClose();
      }
    });

    var prevBtn = lb.querySelector('[data-ease-hl-prev]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        easeCommunityHlStep(-1);
      });
    }
    var nextBtn = lb.querySelector('[data-ease-hl-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        easeCommunityHlStep(1);
      });
    }
  }

  function initCommunityHighlights(root) {
    root = root || document;

    var roots = [];
    if (root.nodeType === 1 && root.matches && root.matches('[data-ease-community-root]')) {
      roots.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-ease-community-root]').forEach(function (el) {
        if (roots.indexOf(el) === -1) roots.push(el);
      });
    }
    if (!roots.length && root.nodeType === 1 && root.querySelector) {
      var innerRoot = root.querySelector('[data-ease-community-root]');
      if (innerRoot) roots.push(innerRoot);
    }
    if (!roots.length && root === document) {
      document.querySelectorAll('[data-ease-community-root]').forEach(function (el) {
        roots.push(el);
      });
    }

    roots.forEach(function (sectionRoot) {
      var lb = sectionRoot.querySelector('[data-ease-community-lightbox]');
      if (!lb) return;
      bindCommunityLightbox(lb);

      sectionRoot.querySelectorAll('[data-ease-hl-json-id]').forEach(function (btn) {
        if (btn.__easeHlBtnBound) return;
        btn.__easeHlBtnBound = true;
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var id = btn.getAttribute('data-ease-hl-json-id');
          var el = id ? document.getElementById(id) : null;
          if (!el) return;
          var parsed;
          try {
            parsed = JSON.parse(el.textContent.trim());
          } catch (err) {
            return;
          }
          if (!Array.isArray(parsed) || !parsed.length) return;
          easeCommunityHlOpen(lb, parsed);
        });
      });
    });
  }

  if (!window.__easeCommunityHlKeyBound) {
    window.__easeCommunityHlKeyBound = true;
    document.addEventListener('keydown', easeCommunityHlOnKeydown);
  }

  if (!window.__easeAudienceMarqueePageShowBound && typeof window !== 'undefined') {
    window.__easeAudienceMarqueePageShowBound = true;
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) {
        initAudienceMarqueeIOS(document);
      }
    });
  }

  /**
   * Studien-Section: horizontales Karussell, Karten per Klick/Enter umdrehen.
   * Nur innerhalb [data-ease-studies-root]; keine globalen Handler.
   */
  function easeStudiesScrollStep(track) {
    var card = track.querySelector('[data-ease-studies-card]');
    if (!card) return 280;
    var gapRaw = window.getComputedStyle(track).gap;
    var gap = parseFloat(gapRaw) || 16;
    return card.getBoundingClientRect().width + gap;
  }

  /** Wie viele Karten gleichzeitig sichtbar sind + wie viele Punkt-Positionen (wie oft „weiter“ sinnvoll). */
  function easeStudiesGetMetrics(track, cards) {
    var n = cards.length;
    if (!n) {
      return { step: 280, dotCount: 0, maxScroll: 0, visible: 0 };
    }
    var step = easeStudiesScrollStep(track);
    var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
    var cw = track.clientWidth;
    var visible = Math.max(1, Math.min(n, Math.floor((cw + gap) / step)));
    var dotCount = Math.max(1, n - visible + 1);
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    return { step: step, dotCount: dotCount, maxScroll: maxScroll, visible: visible };
  }

  function easeStudiesActiveDotIndex(track, step, dotCount, maxScroll) {
    if (dotCount <= 1) return 0;
    var sl = track.scrollLeft;
    if (sl >= maxScroll - 2) return dotCount - 1;
    var idx = Math.round(sl / step);
    return Math.max(0, Math.min(dotCount - 1, idx));
  }

  function easeStudiesSyncDots(track, dotsWrap, cards) {
    var m = easeStudiesGetMetrics(track, cards);
    var dots = dotsWrap.querySelectorAll('.ease-sp-studies__dot');
    if (!dots.length || dots.length !== m.dotCount) return;
    var idx = easeStudiesActiveDotIndex(track, m.step, m.dotCount, m.maxScroll);
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
    });
  }

  function easeStudiesBuildDots(track, dotsWrap, cards) {
    while (dotsWrap.firstChild) {
      dotsWrap.removeChild(dotsWrap.firstChild);
    }
    var m = easeStudiesGetMetrics(track, cards);
    if (!m.dotCount) return;
    var i;
    for (i = 0; i < m.dotCount; i += 1) {
      (function (index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ease-sp-studies__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Ansicht ' + (index + 1) + ' von ' + m.dotCount);
        dot.addEventListener('click', function () {
          var mm = easeStudiesGetMetrics(track, cards);
          var maxScroll = mm.maxScroll;
          var st = mm.step;
          var target =
            index >= mm.dotCount - 1 ? maxScroll : Math.min(index * st, maxScroll);
          track.scrollTo({ left: target, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(dot);
      })(i);
    }
  }

  function easeStudiesRefreshDots(track, dotsWrap, cards) {
    var m = easeStudiesGetMetrics(track, cards);
    var dots = dotsWrap.querySelectorAll('.ease-sp-studies__dot');
    if (!dots.length || dots.length !== m.dotCount) {
      easeStudiesBuildDots(track, dotsWrap, cards);
    }
    easeStudiesSyncDots(track, dotsWrap, cards);
  }

  function initEaseStudiesCarousel(root) {
    var list = [];
    if (root && root.nodeType === 1 && root.matches && root.matches('[data-ease-studies-root]')) {
      list.push(root);
    }
    if (root && root.querySelectorAll) {
      root.querySelectorAll('[data-ease-studies-root]').forEach(function (el) {
        if (list.indexOf(el) === -1) list.push(el);
      });
    }

    list.forEach(function (sec) {
      if (sec.getAttribute('data-ease-studies-initialized') === '1') return;
      var track = sec.querySelector('[data-ease-studies-track]');
      var dotsWrap = sec.querySelector('[data-ease-studies-dots]');
      if (!track || !dotsWrap) return;

      sec.setAttribute('data-ease-studies-initialized', '1');

      var cards = track.querySelectorAll('[data-ease-studies-card]');

      function stepNow() {
        return easeStudiesScrollStep(track);
      }

      function scheduleDots() {
        window.requestAnimationFrame(function () {
          easeStudiesRefreshDots(track, dotsWrap, cards);
        });
      }

      scheduleDots();

      track.addEventListener(
        'scroll',
        function () {
          var m = easeStudiesGetMetrics(track, cards);
          var dots = dotsWrap.querySelectorAll('.ease-sp-studies__dot');
          if (!dots.length || dots.length !== m.dotCount) {
            easeStudiesBuildDots(track, dotsWrap, cards);
          }
          easeStudiesSyncDots(track, dotsWrap, cards);
        },
        { passive: true }
      );

      sec.querySelectorAll('[data-ease-studies-arrow]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-ease-studies-dir'), 10) || 1;
          var st = stepNow();
          track.scrollBy({ left: dir * st, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        });
      });

      cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('[data-ease-studies-stop-flip]')) return;
          card.classList.toggle('ease-sp-studies__card--flipped');
          var open = card.classList.contains('ease-sp-studies__card--flipped');
          card.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        card.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          if (e.target.closest('[data-ease-studies-stop-flip]')) return;
          e.preventDefault();
          card.classList.toggle('ease-sp-studies__card--flipped');
          var open = card.classList.contains('ease-sp-studies__card--flipped');
          card.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      window.addEventListener(
        'resize',
        function () {
          scheduleDots();
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWaveBackgroundCanvas();
      initSingleAccordions(document);
      initEaseHorizontalSliders(document);
      initEaseApplicationsCarousel(document);
      initAudienceMarquee(document);
      initEaseJourneyTimelines();
      initEaseScrollTargets(document);
      initCommunityHighlights(document);
      initEaseStudiesCarousel(document);
    });
  } else {
    initWaveBackgroundCanvas();
    initSingleAccordions(document);
    initEaseHorizontalSliders(document);
    initEaseApplicationsCarousel(document);
    initAudienceMarquee(document);
    initEaseJourneyTimelines();
    initEaseScrollTargets(document);
    initCommunityHighlights(document);
    initEaseStudiesCarousel(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initEaseHorizontalSliders(e.target);
    initEaseApplicationsCarousel(e.target);
    initAudienceMarquee(e.target);
    initCommunityHighlights(e.target);
    initEaseStudiesCarousel(e.target);
    initEaseScrollTargets(e.target);
  });
})();
